// extracted by mini-css-extract-plugin
export default {"mainWrapper":"MainComponent_mainWrapper__2PfQ7","wrapper":"MainComponent_wrapper__s30XG"};